type ContentSidebarLayoutInput = {
  hasPanel: boolean
  isFocused: boolean
  isCompactLayout: boolean
}

type LeftRailAutoCollapseInput = {
  isDesktopSplitContentSidebar: boolean
  viewportWidth: number
  collapseBelowWidth?: number
}

type DesktopContentSidebarTracksInput = {
  panelRatio: number
  minMainContentWidth: number
  desktopWidthPx?: number
}

export const LEFT_RAIL_AUTO_COLLAPSE_MAX_WIDTH = 1600

export function isDesktopSplitContentSidebarLayout({
  hasPanel,
  isFocused,
  isCompactLayout,
}: ContentSidebarLayoutInput): boolean {
  return hasPanel && !isFocused && !isCompactLayout
}

export function isOverlayContentSidebarLayout({
  hasPanel,
  isFocused,
  isCompactLayout,
}: ContentSidebarLayoutInput): boolean {
  return hasPanel && (isFocused || isCompactLayout)
}

export function shouldAutoCollapseLeftRailOnSplit({
  isDesktopSplitContentSidebar,
  viewportWidth,
  collapseBelowWidth = LEFT_RAIL_AUTO_COLLAPSE_MAX_WIDTH,
}: LeftRailAutoCollapseInput): boolean {
  return isDesktopSplitContentSidebar && viewportWidth < collapseBelowWidth
}

export function getDesktopContentSidebarTracks({
  panelRatio,
  minMainContentWidth,
  desktopWidthPx,
}: DesktopContentSidebarTracksInput): { mainTrack: string; sidebarTrack: string } {
  const mainTrack =
    typeof desktopWidthPx === "number"
      ? `max(calc(100% - ${desktopWidthPx}px), ${minMainContentWidth}px)`
      : `max(${Math.round(panelRatio * 10000) / 100}%, ${minMainContentWidth}px)`

  return {
    mainTrack,
    sidebarTrack: `calc(100% - ${mainTrack})`,
  }
}
